<script>
    export let cityData = [
      {
        name: "Norfolk",
        coord: [-76.2859, 36.8508],
      },
      {
        name: "Richmond",
        coord: [-77.436, 37.5407],
      },
      {
        name: "Alexandria",
        coord: [-77.0469, 38.8048],
      },
      {
        name: "Roanoke",
        coord: [-79.9414, 37.271],
      },
    ];
    export let projection;
    
    $: cities = cityData
        .map(d => {
            return {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: d.coord
                },
                properties: {name: d.name}
            };
        });
</script>

<g class="labels">
    {#each cities as city}
        <g class="label" transform={`translate(${projection.centroid(city).join(",")})`}>
            <circle class="shadow" r="4"></circle>
            <circle r="2.5"></circle>
            <text class="shadow" dy="-.5em">{city.properties.name}</text>
            <text dy="-.5em">{city.properties.name}</text>
        </g>
    {/each}
</g>

<style>
    .labels {
        pointer-events: none;
    }

    text {
        font-size: 14px;
        text-anchor: middle;
    }

    text.shadow {
        fill: none;
        stroke: #fff;
        stroke-width: 2.5;
        stroke-opacity: 0.5;
    }

    circle.shadow {
        fill: rgba(255,255,255,0.5);
    }
</style>